import React from 'react'
import { Grid as BaseGrid, styled } from '@mui/material'
import { ArrowDownward } from '@mui/icons-material'
import { Card as BaseCard } from '@chilecompra/react-kit/components'

export const ArrowDownIcon = styled(ArrowDownward)`
  &.MuiSvgIcon-root {
    aspect-ratio: 1/1;
    color: ${props => props.theme.palette.brand.primary};
    height: 24px;
    margin: auto -6px -4px -10px;

    &:hover {
      color: ${props => props.theme.palette.blue[35]};
    }
  }
`

export const Card = styled(({ children, textAlign, ...props }) => <BaseCard {...props}>{children}</BaseCard>)`
  align-items: ${props => props.alignItems};
  display: flex;
  height: ${props => props.height};
  margin: ${props => props.margin};
  width: ${props => props.width};
`

export const CardItem = styled(({ ...props }) => <div {...props} />)`
  align-items: center;
  display: flex;
  flex-direction: ${props => props.direction || 'flex'};
  justify-content: center;
  padding: ${props => props.padding};
`

export const Column = styled(({ flexBasis, flexGrow, width, padding, ...props }) => <BaseGrid item {...props} />)`
  &.MuiGrid-root {
    flex-basis: ${props => props.flexBasis};
    flex-grow: ${props => props.flexGrow};
    margin: 0;
    width: ${props => props.width};
  }
  &.MuiGrid-root:first-child {
    padding: ${props => props.padding};
  }
`

export const Link = styled(({ children, textAlign, textDecoration, ...props }) => <a {...props}>{children}</a>)`
  align-content: baseline;
  align-items: center;
  bottom: ${props => (props.position === 'absolute' ? '35px' : '0')};
  color: ${({ color, theme }) => (color === 'primary' ? theme.palette.blue[50] : theme.palette.gray[50])};
  cursor: pointer;
  display: ${props => props.display || 'flex'};
  font-family: Roboto;
  font-size: 14px;
  font-style: ${props => (props.italic ? 'italic' : 'initial')};
  line-height: 18px;
  position: ${props => props.position};
  text-align: ${props => props.textAlign || 'initial'};
  text-decoration: ${props => props.textDecoration || 'none'};

  ${props => props.theme.breakpoints.only('xs')} {
    align-items: end;
    flex-wrap: wrap;
    justify-content: center;
    position: relative;
    top: 5px;
  }

  &:hover {
    color: ${props => props.theme.palette.blue[35]};
    & svg {
      color: ${props => props.theme.palette.blue[35]};
    }
  }
`

export const NotFoundImg = styled('img')`
  color: ${props => props.theme.palette.brand.black3};
  height: auto;
  margin: ${props => props.margin};
  width: 82px;
`

export const Root = styled('div')`
  width: 100%;
`

export const Row = styled(({ ...props }) => <BaseGrid container {...props} />)``

export const Separator = styled('hr')`
  border: 0;
  border-top: 1px solid ${props => props.theme.palette.custom.gray[75.5]};
  box-sizing: content-box;
  height: 0;
  margin: 24px 0;
  overflow: visible;
`

export const Strong = styled('span')`
  font-weight: bold;
`

export const WarningImg = styled('img')`
  color: ${props => props.theme.palette.brand.black3};
  height: 48px;
  margin: ${props => props.margin};
  width: 48px;
`
